import { BtnSecondary } from '@components/buttons';
import { MemberCard } from './member-card';
import { Member, Segment, SegmentCounts } from './types';

type Props = {
  segment: Segment;
  onSegmentChange: (s: Segment) => void;
  members: Member[];
  hasMore: boolean;
  isLoading: boolean;
  onShowMore: () => void;
  segments: SegmentCounts;
  periodDays: number;
  courseId?: string;
};

function TabButton({
  label,
  count,
  isActive,
  onClick,
}: {
  label: string;
  count: number;
  isActive: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      class={`px-4 py-2 text-sm font-medium rounded-md ${
        isActive
          ? 'bg-indigo-50 text-indigo-700'
          : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
      }`}
    >
      {label} ({count})
    </button>
  );
}

function buildCsvUrl(segment: Segment, periodDays: number, courseId?: string) {
  const params = new URLSearchParams({ segment, periodDays: String(periodDays) });
  if (courseId) {
    params.set('courseId', courseId);
  }
  return `/csv/engagement-members.csv?${params.toString()}`;
}

export function MemberList({
  segment,
  onSegmentChange,
  members,
  hasMore,
  isLoading,
  onShowMore,
  segments,
  periodDays,
  courseId,
}: Props) {
  return (
    <div>
      <div class="flex items-center gap-2 mb-6">
        <TabButton
          label="Champions"
          count={segments.active}
          isActive={segment === 'champions'}
          onClick={() => onSegmentChange('champions')}
        />
        <TabButton
          label="Fading"
          count={segments.fading}
          isActive={segment === 'fading'}
          onClick={() => onSegmentChange('fading')}
        />
        <TabButton
          label="Inactive"
          count={segments.inactive}
          isActive={segment === 'inactive'}
          onClick={() => onSegmentChange('inactive')}
        />
        <TabButton
          label="New"
          count={segments.newMembers}
          isActive={segment === 'new'}
          onClick={() => onSegmentChange('new')}
        />
        <a
          href={buildCsvUrl(segment, periodDays, courseId)}
          class="ml-auto text-sm text-indigo-600 hover:text-indigo-800 flex items-center gap-1"
          download
        >
          Download CSV
        </a>
      </div>

      {members.length === 0 && !isLoading && (
        <p class="text-gray-500 text-sm py-8 text-center">No members in this segment.</p>
      )}

      <div class="flex flex-col gap-3">
        {members.map((m) => (
          <MemberCard key={m.id} member={m} segment={segment} />
        ))}
      </div>

      {hasMore && (
        <div class="text-center mt-6">
          <BtnSecondary isLoading={isLoading} onClick={onShowMore}>
            Show more
          </BtnSecondary>
        </div>
      )}
    </div>
  );
}
